export const SET_CLOUD_CANNON_CONTENT = 'SET_CLOUD_CANNON_CONTENT'
export const SET_CLOUD_CANNON_CONTENT_LOADING = 'SET_CLOUD_CANNON_CONTENT_LOADING'
export const SET_CLOUD_CANNON_FOOTER_CONTENT = 'SET_CLOUD_CANNON_FOOTER_CONTENT'
export const SET_CLOUD_CANNON_FOOTER_CONTENT_LOADING = 'SET_CLOUD_CANNON_FOOTER_CONTENT_LOADING'
